import { InspectionSchema } from '@eigtech/inspections-types';
import { z } from 'zod';
export const JobInspectionStartedDetailsSchema = z.object({
    inspection: InspectionSchema,
});
export const JobInspectionEndedDetailsSchema = z.object({
    inspection: InspectionSchema,
});
export const JobInspectionReviewedDetailsSchema = z.object({
    inspection: InspectionSchema,
});
